import { withAuthorization } from "../../authentication/Session/withAuthorization";
import { onlyCustomer } from "../../authentication/authorizations";
import { lazy } from "react";
import { DefaultPage } from "../../structure/Page/DefaultPage/DefaultPage";

const CollaborationPageContent = lazy(() => import("./CollaborationPageContent"));

function CollaborationPageInternal() {
    return (
        <DefaultPage>
            <CollaborationPageContent />
        </DefaultPage>
    );
}

export const CollaborationPage = withAuthorization(onlyCustomer)(CollaborationPageInternal);
